import { FaCreditCard, FaTriangleExclamation } from "react-icons/fa6";
import { PaymentCardShortInfo } from "@/features/payment/types";
import { Badge } from "@/components/ui/Badge";

interface CardStatusBadgeProps {
  cardInfo: PaymentCardShortInfo | null;
}

export function CardStatusBadge({ cardInfo }: CardStatusBadgeProps) {
  if (cardInfo?.last4) {
    return (
      <Badge variant="success">
        <FaCreditCard size={12} />
        {cardInfo.brand} {cardInfo.last4}
      </Badge>
    );
  }

  return (
    <Badge variant="danger">
      <FaTriangleExclamation size={12} />
      No Card
    </Badge>
  );
}
